// react
import { ReactNode } from 'react';

// recharts
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';

// mui
import { Box, Typography, useTheme } from '@mui/material';

// charts
import { ChartTooltip } from '../ChartTooltip/ChartTooltip';

// props
export interface ChartLineData {
	label: string;
	value: number;
}

export interface ChartLineProps {
	data: ChartLineData[];
	title?: ReactNode;
}

export const ChartLine = ({ data, title }: ChartLineProps) => {
	const theme = useTheme();

	return (
		<Box sx={{ height: '100%' }}>
			{title && (
				<Box sx={{ mb: 2 }}>
					{typeof title === 'string' ? <Typography variant="h6">{title}</Typography> : title}
				</Box>
			)}
			<ResponsiveContainer minHeight={300} height="100%" width="100%">
				<LineChart
					data={data}
					margin={{
						bottom: 5,
						left: 10,
						right: 10,
						top: 5,
					}}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="label" />
					<YAxis />
					<Tooltip content={<ChartTooltip type="LINE" />} />
					<Line
						dataKey="value"
						dot={{ fill: theme.palette.brand.blue['500'], r: 4 }}
						stroke={theme.palette.brand.blue['500']}
						strokeWidth={2}
						type="monotone"
					/>
				</LineChart>
			</ResponsiveContainer>
		</Box>
	);
};
